





















































































import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import { currencies } from '@/utils/currencies'
import CountryFlag from 'vue-country-flag'
import { getSymbolFromCurrency } from '@/utils/functions'
import { Exchange } from '@/utils/interfaces'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appCountryFlag: CountryFlag,
  },
  props: {
    editExchange: [Object] as PropType<null | Exchange>,
  },
  data() {
    return {
      currencies: currencies,
      getCurrencySymbol: getSymbolFromCurrency,
      from: currencies[0],
      to: currencies[1],
      amount: 1,
    }
  },
  computed: {
    small(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    onSuccess(): void {
      const payload = {
        from: {
          currency: this.from.currency,
          amount: 1,
          flag: this.from.flag,
        },
        to: {
          currency: this.to.currency,
          amount: this.amount,
          flag: this.to.flag,
        },
      }
      this.$emit('new-exchange', payload)
      this.$emit('input', false)
    },
  },
  watch: {
    editExchange(value: Exchange): void {
      if (value) {
        this.to = value.to
        this.from = value.from
        this.amount = value.to.amount
      }
    },
  },
  created(): void {
    if (this.editExchange) {
      this.to = this.editExchange.to
      this.from = this.editExchange.from
    }
  },
})
